
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reset-password/verify",
      function () {
        return require("private-next-pages/reset-password/verify.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reset-password/verify"])
      });
    }
  